import { ErrorOperation } from "./ErrorOperation";
import { FilterItemColumnType } from "./FilterItemColumnType";

export class FilterItemOperator
{
    static all = {
        equals: new FilterItemOperator("Equals", "=", 1, (type: FilterItemColumnType) => { return type != FilterItemColumnType.Unknown; }),
        contains: new FilterItemOperator("Contains", ":", 1, (type: FilterItemColumnType) => { return type != FilterItemColumnType.Unknown && type != FilterItemColumnType.Boolean; }),
        regex: new FilterItemOperator("Regex", "*", 1, (type: FilterItemColumnType) => { return type != FilterItemColumnType.Unknown && type != FilterItemColumnType.Boolean; }),
        empty: new FilterItemOperator("Empty", "?", 0, (type: FilterItemColumnType) => { return type != FilterItemColumnType.Unknown; }),
        exists: new FilterItemOperator("Exists", "??", 0, (_: FilterItemColumnType, required: boolean) => { return !required; }),
        includes: new FilterItemOperator("Includes", "()", 1, (_: FilterItemColumnType, required: boolean) => { return !required; }),
        startswith: new FilterItemOperator("Starts With", "(", 1, (type: FilterItemColumnType) => { return type == FilterItemColumnType.String; }),
        endswith: new FilterItemOperator("Ends With", ")", 1, (type: FilterItemColumnType) => { return type == FilterItemColumnType.String; }),
        lessthan: new FilterItemOperator("Less Than", "<", 1, (type: FilterItemColumnType) => { return [FilterItemColumnType.Number, FilterItemColumnType.DateTime, FilterItemColumnType.Date, FilterItemColumnType.Time].includes(type); }),
        lessthanequal: new FilterItemOperator("Less Than Equal", "<=", 1, (type: FilterItemColumnType) => { return [FilterItemColumnType.Number, FilterItemColumnType.DateTime, FilterItemColumnType.Date, FilterItemColumnType.Time].includes(type); }),
        morethan: new FilterItemOperator("More Than", ">", 1, (type: FilterItemColumnType) => { return [FilterItemColumnType.Number, FilterItemColumnType.DateTime, FilterItemColumnType.Date, FilterItemColumnType.Time].includes(type); }),
        morethanequal: new FilterItemOperator("More Than Equal", ">=", 1, (type: FilterItemColumnType) => { return [FilterItemColumnType.Number, FilterItemColumnType.DateTime, FilterItemColumnType.Date, FilterItemColumnType.Time].includes(type); }),
    };
    static getAll(): FilterItemOperator[]
    {
        return Object.keys(FilterItemOperator.all).map(name => (FilterItemOperator.all as any)[name]);
    }
    static getAllByType(type: FilterItemColumnType, required: boolean): FilterItemOperator[]
    {
        return FilterItemOperator.getAll().filter(f => f.accepts(type, required));
    }
    static getByName(name: string): FilterItemOperator
    {
        let found = (FilterItemOperator.all as any)[name.toLowerCase()];
        if (!found)
            ErrorOperation.throwHTTP(400, `Could not find operator by name: '${name}'. Valid values are ${this.getAll().map(x => x.name).join(",")}`);
        return found;
    }
    static getBySign(sign: string): FilterItemOperator
    {
        let found = FilterItemOperator.getAll().filter(x => x.sign == sign);
        if (found.length == 0)
            ErrorOperation.throwHTTP(400, `Could not find operator by sign: '${sign}'. Valid values are ${this.getAll().map(x => x.sign).join(",")}`);
        return found[0];
    }
    name: string;
    sign: string;
    count: number;
    accepts: (type: FilterItemColumnType, required: boolean) => boolean;
    constructor(name: string, sign: string, count: number, accepts: (type: FilterItemColumnType, required: boolean) => boolean)
    {
        this.name = name;
        this.sign = sign;
        this.count = count;
        this.accepts = accepts;
    }
}